import { InstitutionProps } from '../../../../models/arc-epi-props';
import { PensionPlanDetail } from '../../plan-history/plan-history-models';
import { AdoptionMemberType, ContributionAmountType, EmployerContributionStatusType, LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../models/plan-adoption-form-models';
import { mapApiQccoValueToForm } from '../shared/qcco-questions-shared';

export function GetAmendLayDcFormContentModel(baseContent: LayDcPlanAdoptionContentModel, institutionSettings: InstitutionProps): LayDcPlanAdoptionContentModel {
    return {
        ...baseContent,
        adoptionDateLabel: institutionSettings?.amendFormDateLabel,
        adoptingPlanStepperLabel: institutionSettings?.amendLayDCPlanStepperLabel,
        adoptingInstitutionLabel: institutionSettings?.amendLayDCInstitutionLabel,        
        adoptDetailsTitle: institutionSettings?.amendLayDCDetailsTitle,
        planAdoptionDetailTitle: institutionSettings?.amendLayDCDetailsTitle,
    };
}

export function GetAmendRsvpFormContentModel(baseContent: LayDcPlanAdoptionContentModel, institutionSettings: InstitutionProps): LayDcPlanAdoptionContentModel {
    return {
        ...baseContent,
        adoptionDateLabel: institutionSettings?.amendFormDateLabel,
        adoptingPlanStepperLabel: institutionSettings?.amendRSVPPlanStepperLabel,
        adoptingInstitutionLabel: institutionSettings?.amendRSVPInstitutionLabel,
        adoptDetailsTitle: institutionSettings?.amendRSVPDetailsTitle,
        planAdoptionDetailTitle: institutionSettings?.amendRSVPDetailsTitle,
    };
}

export function MapEligiblePopulationToAdoptionMemberType(eligiblePopulation: string): AdoptionMemberType {
    switch (eligiblePopulation) {
        case 'Clergy':
            return AdoptionMemberType.Clergy;
        case 'Lay':
            return AdoptionMemberType.Lay;

        case 'Clergy and Lay':
        default:
            return AdoptionMemberType.Both;
    }    
}

export function GetLayDCPreviousValues(dcPlanDetail: PensionPlanDetail, defaultValues: LayDcPlanFormModel): LayDcPlanFormModel {

    if (!dcPlanDetail) return null;

    const historyDetail = dcPlanDetail?.history[0];
    const qcco_status_history = historyDetail?.qcco_status_history;

    const serverValues: LayDcPlanFormModel = {
        ...defaultValues,

        planHistoryId: historyDetail?.id,
        planId: dcPlanDetail.id,
        qccoStatusId: qcco_status_history[0]?.id,

        previousAdoptionDate: historyDetail.adoption_date,        
        allow_multiple_contributions: (historyDetail.allow_multiple_contribution_schedules === 'Yes'),
        employer_base_contribution_percentage: Number(historyDetail.employer_base?.replace('%', '')),
        employer_match_contribution_percentage: Number(historyDetail.employer_match?.replace('%', '')),
        minimum_scheduleds_hours: Number(historyDetail.minimum_scheduled_hours?.replace(',', '')),

        qccoQuestion1: mapApiQccoValueToForm(qcco_status_history[0]?.supported_by_church),
        qccoQuestion2: mapApiQccoValueToForm(qcco_status_history[0]?.offers_services_to_public),
        qccoQuestion3: mapApiQccoValueToForm(qcco_status_history[0]?.receives_gov_support),
    };

    return serverValues;
}

export function GetRsvpPreviousValues(rsvpPlanDetail: PensionPlanDetail, defaultValues: LayDcPlanFormModel): LayDcPlanFormModel {

    if (!rsvpPlanDetail) return null;
    
    const historyDetail = rsvpPlanDetail?.history[0];
    const qcco_status_history = historyDetail?.qcco_status_history;

    const isEmployerBasePercentage = historyDetail?.employer_base?.includes('%');
    const isEmployerMatchPercentage = historyDetail?.employer_match?.includes('%');

    const serverValues: LayDcPlanFormModel = {
        ...defaultValues,

        planHistoryId: historyDetail?.id,
        planId: rsvpPlanDetail.id,
        qccoStatusId: qcco_status_history[0]?.id,

        previousAdoptionDate: historyDetail.adoption_date,        
        allow_multiple_contributions: (historyDetail.allow_multiple_contribution_schedules === 'Yes'),
        minimum_scheduleds_hours: Number(historyDetail.minimum_scheduled_hours?.replace(',', '')),
        member_type: MapEligiblePopulationToAdoptionMemberType(historyDetail.eligible_population),

        employer_contribution_status: historyDetail.contribution_type as EmployerContributionStatusType,

        qccoQuestion1: mapApiQccoValueToForm(qcco_status_history[0]?.supported_by_church),
        qccoQuestion2: mapApiQccoValueToForm(qcco_status_history[0]?.offers_services_to_public),
        qccoQuestion3: mapApiQccoValueToForm(qcco_status_history[0]?.receives_gov_support),
    };

    if (serverValues.employer_contribution_status === EmployerContributionStatusType.Scheduled) {
        serverValues.employer_base_contribution_amount_type = isEmployerBasePercentage ? ContributionAmountType.Percentage : ContributionAmountType.Dollar;
        serverValues.employer_match_contribution_amount_type = isEmployerMatchPercentage ? ContributionAmountType.Percentage : ContributionAmountType.Dollar;

        if (isEmployerBasePercentage) {
            serverValues.employer_base_contribution_percentage = Number(historyDetail.employer_base?.replace('%', ''));
            serverValues.employer_base_contribution_amount = 0;
        } else {
            serverValues.employer_base_contribution_percentage = 0;
            serverValues.employer_base_contribution_amount = Number(historyDetail.employer_base?.replace('$', ''));
        }

        if (isEmployerMatchPercentage) {
            serverValues.employer_match_contribution_percentage = Number(historyDetail.employer_match?.replace('%', ''));
            serverValues.employer_match_contribution_amount = 0;
        } else {
            serverValues.employer_match_contribution_percentage = 0;
            serverValues.employer_match_contribution_amount = Number(historyDetail.employer_match?.replace('$', ''));
        }
    }

    return serverValues;
}